import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LogoutFunc as UserLogout } from "../store/Slice/AuthSlice";
import { LogoutFunc as AdvisorLogout } from "../store/Slice/AdvisorAuthSlice";
import { AUTHENTICATED_ROUTES } from "../constants/routeConstants";
import ChevronUp from "../assets/images/chevron-up.png";
import { MenuOutlined } from "@ant-design/icons";

const Header = ({ onMenuClick }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const logout = () => {
    dispatch(AdvisorLogout());
    dispatch(UserLogout());
    navigate("/");
  };

  const getInitials = (name) => {
    if (!name) return "U";
    const nameStr = Array.isArray(name) ? name[0] : String(name);
    if (!nameStr || nameStr.length === 0) return "U";
    return nameStr.charAt(0).toUpperCase();
  };

  const getAvatarColor = (name) => {
    if (!name) return "bg-blue-500";
    const nameStr = Array.isArray(name) ? name[0] : String(name);
    if (!nameStr || nameStr.length === 0) return "bg-blue-500";
    const colors = [
      "bg-blue-500",
      "bg-green-500",
      "bg-purple-500",
      "bg-pink-500",
      "bg-indigo-500",
      "bg-red-500",
      "bg-yellow-500",
      "bg-teal-500",
    ];
    const index = nameStr.charCodeAt(0) % colors.length;
    return colors[index];
  };

  return (
    <div className="bg-gradient-to-r from-primary to-primary-green px-4 py-4 lg:px-6 lg:py-6 flex justify-between items-center transition-all duration-200">
      <div className="flex items-center gap-3">
        {onMenuClick && (
          <button
            type="button"
            className="xl:hidden p-2 bg-white rounded-lg shadow-md hover:bg-gray-50 transition-colors"
            aria-label="Toggle menu"
            onClick={onMenuClick}
          >
            <MenuOutlined className="text-xl text-gray-700" />
          </button>
        )}
        <div className="text-white text-base lg:text-lg font-medium">
          <p className="m-0">Hello, {user}</p>
        </div>
      </div>
      <div className="flex items-center justify-end gap-2 lg:gap-3">
        {/* <div className="text-white w-12 text-base cursor-pointer">
          <BellOutlined />
        </div>
        <div className="text-white w-12 text-base cursor-pointer">
          <SettingOutlined />
        </div> */}
        <div className="relative">
          <div
            className="flex items-center gap-1 lg:gap-2 cursor-pointer"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            <div
              className={`w-10 h-10 lg:w-12 lg:h-12 rounded-full flex items-center justify-center text-white text-base lg:text-xl font-bold flex-shrink-0 ${getAvatarColor(
                user,
              )}`}
            >
              {getInitials(user)}
            </div>
            <img
              src={ChevronUp}
              alt="arrow-up"
              className="w-4 h-4 lg:w-5 lg:h-5 flex-shrink-0 transition-transform duration-200"
              style={{
                transform: dropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
              }}
            />
          </div>
          {dropdownOpen && (
            <div className="absolute top-full mt-2 right-0 min-w-[160px] lg:min-w-[200px] bg-white rounded-lg shadow-lg z-50">
              <div className="py-1">
                <button
                  onClick={() => {
                    navigate(AUTHENTICATED_ROUTES.FAQS);
                    setDropdownOpen(false);
                  }}
                  className="w-full text-left px-4 py-2 lg:py-3 text-sm lg:text-base text-[#222222] hover:bg-gray-100 cursor-pointer border-none bg-transparent transition-colors"
                >
                  FAQs
                </button>
                <div className="border-t border-gray-200 my-1"></div>
                <button
                  onClick={() => {
                    logout();
                    setDropdownOpen(false);
                  }}
                  className="w-full text-left px-4 py-2 lg:py-3 text-sm lg:text-base text-[#222222] hover:bg-gray-100 cursor-pointer border-none bg-transparent transition-colors"
                >
                  Logout
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
